import cls from '@utils/css-select';
import PageContainer from 'containers/ac-containers/page-container';
import { useTranslation } from 'hooks/use-translation';
import Feature from 'pages/offical/faq/components/feature/main';
import Technical from 'pages/offical/faq/components/technical/main';
import React from 'react';
import styles from './styles.scss';

const cx = cls(styles)

function FaqContent() {
	const { transData } = useTranslation('faq')
	return (
		<div className={cx('faq-page-content')}>
			<h1 className={cx('page-title')}>
				<span>
					{transData.h1}

					{/* <img src='https://web-data.zmlearn.com/image/nCCJT7FqPrrLXmJKBf5Z7G/faq-title.png' alt='fAQs' loading='lazy' /> */}
				</span>
			</h1>
			<Feature className={cx('feature-container')} />
			<Technical className={cx('technical-container')} />
		</div>
	)
}

function Faq() {
	return (
		<PageContainer className={cx('faq-page-container')}>
			<section style={{ 'overflow': 'hidden' }}>
				<FaqContent />
			</section>
		</PageContainer>

	)
}

export default Faq

